import Mortgage from "../Loan/Mortgage";
import OverpayablePeriod from "../Period/OverpayablePeriod";
import UnitInterface from "../Unit/UnitInterface";
import AbstractOverpayment from "./AbstractOverpayment";

export default class OneOffOverpayment extends AbstractOverpayment {
  private period: number;

  constructor(amount: UnitInterface, period: number, mortgage: Mortgage) {
    super();
    this.amount = amount;
    this.period = period;
    this.mortgage = mortgage;
  }

  getOverpayment(per: number, period: OverpayablePeriod): number {
    if (this.period == per) {
      return Math.min(this.amount.toValue(), period.getBalance() - period.getPayment());
    }

    return 0;
  }
}